import axios from "axios";
import { config } from "../../utils/config";
import { getCookie } from "../../utils/cookieHandler";
import { useState } from "react";
import { findDataInFields } from "../../utils/helperFuctions";

const ActionsList = ({ handleSubmit, id, callPopUp, currentFields, refreshLockStatus }) => {
  const [emailSendloading, setEmailSendLoading] = useState(false);

  return (
    <div className="border-t border-gray-200 bg-gray-50  p-6 rounded-lg shadow max-md:mx-3">
      <div className="font-medium pb-4">Actions</div>
      <div className="space-y-2">
      <div
        className="text-primary text-sm cursor-pointer hover:underline hover:font-medium block"
        onClick={async (e) => {
          await handleSubmit(e);
          const response = await axios.get(
            `${config.apiUrl}/api/auth/pdf-token`,
            {
              headers: { Authorization: `Bearer ${getCookie("_AT")}` },
            }
          );

          const tempToken = response.data.token;

          const pdfUrl = `${config.apiUrl}/api/reservations/ordersummary/${id}?access_token=${tempToken}`;

          window.open(`${pdfUrl}`, "_blank");
        }}
      >
        Generate order summary
      </div>
      <div
        onClick={async (e) => {
          e.preventDefault();
          if (emailSendloading === true) {
            return;
          }
          await handleSubmit(e);
          setEmailSendLoading(true);
          const res = await fetch(
            `${config.apiUrl}/api/reservations/shareordersummarybyemail/${id}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${getCookie("_AT")}`,
              },
            }
          );

          const result = await res.json();

          if (callPopUp instanceof Function && result.success === true) {
            callPopUp({
              title: "Email Sent Successfully",
              description: `The order summary has been sent to ${findDataInFields(
                currentFields,
                "contact.email"
              )}`,
              showPopUp: true,
              hideCancel: true,
            });
          }

          setEmailSendLoading(false);
          if (result.error != null) {
            if (callPopUp instanceof Function) {
              callPopUp({
                title: "Error ",
                description: "Contract not generated.",
                isError: true,
                showPopUp: true,
                hideCancel: true,
              });
            }
          }
        }}
        className="text-primary text-sm cursor-pointer hover:underline hover:font-medium"
      >
        {emailSendloading === true ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="animate-spin h-5 w-5"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="#5729BC"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
        ) : (
          "Email order summary"
        )}
      </div>
      </div>
    </div>
  );
};

export default ActionsList;
